import React from 'react';
import styles from './footer.module.css';
import { NavLink, Link } from "react-router-dom";

const Footer = () => {
  const imagePaths = {
    axldroneLogo: '/Assets/Images/axldroneLogo.svg',
    ISOlogo: '/Assets/Images/ISO.svg',
    DGCAlogo: '/Assets/Images/DGCA.svg',
    GemSeller: '/Assets/Images/GemSeller.svg',
    linkedin: '/Assets/Images/linkedin.svg',
    gmail: '/Assets/Images/gmail.svg',
    facebook: '/Assets/Images/facebook.svg',
    // whatsapp: '/Assets/Images/whatsap.svg',
    Xlogo: '/Assets/Images/Xlogo.svg'
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.leftSection}>
          <Link to="/">
            <img 
              src={imagePaths.axldroneLogo} 
              alt="AxlDrone Logo" 
              className={styles.logo}
              loading="lazy"
            />
          </Link>

          <div className={styles.gemInfo}>
            <img 
              src={imagePaths.GemSeller} 
              alt="GeM Seller" 
              className={styles.gemIcon}
              loading="lazy"
            />
            <div className={styles.gemText}>
              <span>GeM Seller Id:</span>
              <span>29QX240011234578</span>
            </div>
          </div>
        </div>

        <div className={styles.navSection}>
          <NavLink to="/AboutUs" className={styles.navLink}>About Us</NavLink>
          <NavLink to="/careers" className={styles.navLink}>Careers</NavLink>
          <NavLink to="/contact-us" className={styles.navLink}>Contact Us</NavLink>
          <NavLink to="/Media" className={styles.navLink}>Media</NavLink>
        </div>

        <div className={styles.navSection}>
          <NavLink to="/News" className={styles.navLink}>News</NavLink>
          <NavLink to="/axl30" className={styles.navLink}>Drone Kit</NavLink>
          <NavLink to="/Blog" className={styles.navLink}>Blog</NavLink>
          <NavLink to="/RentADrone" className={styles.navLink}>Rent a Drone</NavLink>
        </div>

        <div className={styles.navSection}>
          <NavLink to="/AakashSoftware" className={styles.navLink}>Aakash Platform</NavLink>
          <NavLink to="/peregrine" className={styles.navLink}>Peregrine</NavLink>
          <NavLink to="/TermsOfUse" className={styles.navLink}>Terms of Use</NavLink>
          <NavLink to="/privacypolicy" className={styles.navLink}>Privacy Policy</NavLink>
        </div>

        <div className={styles.certSection}>
          <img 
            src={imagePaths.DGCAlogo} 
            alt="DGCA Certified" 
            className={styles.certLogo}
            loading="lazy"
          />
          <img 
            src={imagePaths.ISOlogo} 
            alt="ISO 9001:2015" 
            className={styles.certLogo}
            loading="lazy"
          />
        </div>
      </div>

      <div className={styles.footerBottom}>
        <span className={styles.copyright}>©2025 Axldrone India Pvt Ltd. All Rights Reserved</span>

        <div className={styles.socialLinks}>
          <a href="mailto:info@axldrone.com" className={styles.socialLink}>
            <img 
              src={imagePaths.gmail} 
              alt="Email" 
              className={styles.socialIcon}
              loading="lazy"
            />
          </a>
          <a href="https://www.facebook.com/axldronepvtltd" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <img 
              src={imagePaths.facebook} 
              alt="Facebook" 
              className={styles.socialIcon}
              loading="lazy"
            />
          </a>
          {/* <a 
            href="https://wa.me/+919497717654" 
            target="_blank" 
            rel="noopener noreferrer" 
            className={styles.socialLink}
          >
            <img 
              src={imagePaths.whatsapp} 
              alt="WhatsApp" 
              className={styles.socialIcon}
              loading="lazy"
            />
          </a> */}
          <a href="https://x.com/AxldroneL" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <img 
              src={imagePaths.Xlogo} 
              alt="Twitter/X" 
              className={styles.socialIcon}
              loading="lazy"
            />
          </a>
          <a href="https://linkedin.com/company/axldrone" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
            <img 
              src={imagePaths.linkedin} 
              alt="LinkedIn" 
              className={styles.socialIcon}
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
